import * as React from 'react';
import styles from './Modal.styles';
import withStyles, { WithStyles } from '@mui/styles/withStyles';
import { Grid, Paper, Typography } from '@mui/material';
import Button from '../Button';
import MuiModal from '@mui/material/Modal';
import clsx from 'clsx';

interface ModalProps extends WithStyles<typeof styles> {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  submitText?: string;
  cancelText?: string;
  withCancelBtn?: boolean;
  childrenAlignment?: React.CSSProperties['justifyContent'];
  submitAction?: () => void;
  canSubmit?: boolean;
  canCancel?: boolean;
  loading?: boolean;
  submitButtonError?: boolean;
  paperClassName?: string;
  isDeleteBtn?: boolean;
}

const Modal: React.FC<React.PropsWithChildren<ModalProps>> = ({
  classes,
  isOpen,
  children,
  onClose,
  title,
  submitText,
  cancelText,
  submitAction,
  canSubmit = true,
  canCancel = true,
  withCancelBtn = true,
  childrenAlignment = 'center',
  loading,
  submitButtonError,
  paperClassName,
  isDeleteBtn,
}) => {
  if (!submitText && isDeleteBtn) {
    submitText = 'Delete';
  }

  const content =
    typeof children === 'string' ? <span className={classes.text}>{children}</span> : children;

  return (
    <MuiModal open={isOpen}>
      <Grid
        container
        className={classes.popupContent}
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          direction: 'row',
        }}
      >
        <Paper className={clsx(classes.paper, paperClassName)}>
          <Grid container spacing={2}>
            <Grid
              container
              size={12}
              sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                direction: 'row',
              }}
            >
              <Typography variant="h4" component="h4" style={{ fontWeight: 500, fontSize: 24 }}>
                {title}
              </Typography>
            </Grid>

            <Grid
              container
              size={12}
              className={classes.childContent}
              sx={{
                justifyContent: { childrenAlignment },
                alignItems: 'center',
                direction: 'row',
              }}
            >
              {content}
            </Grid>

            <Grid
              container
              size={12}
              className={classes.buttonsSection}
              sx={{
                justifyContent: 'flex-end',
                alignItems: 'center',
                direction: 'row',
              }}
            >
              {withCancelBtn && (
                <Button
                  type="button"
                  text={cancelText || 'Cancel'}
                  variant="text"
                  className={classes.cancelButton}
                  onClick={onClose}
                  disabled={!canCancel}
                />
              )}
              {submitText && (
                <Button
                  type="submit"
                  text={submitText}
                  onClick={submitAction}
                  className={clsx(classes.submitButton, {
                    [classes.deleteButton]: isDeleteBtn,
                  })}
                  disabled={!canSubmit || loading}
                  loading={loading}
                  error={submitButtonError}
                />
              )}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </MuiModal>
  );
};

export default withStyles(styles)(Modal);
